import React from 'react';
import InvoiceListItem from "./InvoiceListItem";

export default function InvoicesResultList({results, onSelect, newSearch}) {
    return (
        <div>
            <div className="float-right">
                <a href="#"
                   onClick={(e) => {e.preventDefault(); newSearch();}}
                >New Search</a>
            </div>
            <h2>Invoices</h2>
            <div className="list-group">
                {results.length === 0 && <p className="alert alert-warning">No Invoices found for Sales Order#</p>}
                {results && results.map(item => {
                    return (
                        <InvoiceListItem key={item} invoiceNumber={item} isActive={false} onSelect={onSelect}/>
                    );
                })}
            </div>
        </div>
    );
}